import { connect } from 'react-redux';
import { actions } from '../../../../../../redux/modules/admin/packing';
import PackingList from './Packing';


const ms2p = (state) => {
  return {
    ...state.packings,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(PackingList);
